var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Col, Popconfirm } from 'antd';
import Upload from 'components/Upload';
import { Input, TextArea, Button, Select } from 'ui/styled';
import { BLUE } from 'ui/constants';
import { isNilOrEmpty } from 'utils/helpers';
import { FormItem, AttachmentContainer, StyledRow } from '../styled';
var NewAttachment = function (_a) {
    var index = _a.index, _b = _a.attachHandler, attachHandler = _b === void 0 ? function () { } : _b, _c = _a.onRemoveAttachment, onRemoveAttachment = _c === void 0 ? function () { } : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.attachmentOptions, attachmentOptions = _e === void 0 ? null : _e, _f = _a.fieldName, fieldName = _f === void 0 ? [] : _f;
    var _g = useState(false), loading = _g[0], setLoading = _g[1];
    var onAttach = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, attachHandler(file, index)];
                case 1:
                    _a.sent();
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var titleFieldName = (fieldName === null || fieldName === void 0 ? void 0 : fieldName.length)
        ? __spreadArray(__spreadArray([], fieldName, true), [index, 'title'], false) : ['attachments', index, 'title'];
    var showSelect = !isNilOrEmpty(attachmentOptions);
    return (_jsxs(StyledRow, { gutter: 16, children: [_jsx(Col, { span: 6, children: _jsx(AttachmentContainer, { children: _jsx(FormItem, { name: (fieldName === null || fieldName === void 0 ? void 0 : fieldName.length)
                            ? __spreadArray(__spreadArray([], fieldName, true), [index, 'file'], false) : ['attachments', index, 'file'], children: _jsx(Upload, { attach: onAttach, disabled: loading || disabled, type: "document" }) }) }) }), _jsxs(Col, { span: 18, children: [_jsxs(StyledRow, { gutter: 16, children: [_jsx(Col, { span: 18, children: showSelect ? (_jsx(FormItem, { name: titleFieldName, rules: [
                                        {
                                            required: true,
                                            message: 'Please choose the attachment type'
                                        }
                                    ], children: _jsx(Select, { placeholder: "Title", disabled: loading || disabled, options: attachmentOptions, "data-test": "createTicketTitleSelect" }) })) : (_jsx(FormItem, { name: ['attachments', index, 'title'], children: _jsx(Input, { placeholder: "Title", disabled: loading || disabled, "data-test": "createTicketTitleInput" }) })) }), _jsx(Col, { span: 6, children: _jsx(Popconfirm, { title: "Are you sure you want to delete this attachment?", onConfirm: function () { return onRemoveAttachment(index); }, okButtonProps: {
                                        'data-test': 'attachmentsPopConfirmOkBtn',
                                        style: {
                                            background: BLUE,
                                            border: BLUE,
                                            borderRadius: 6
                                        }
                                    }, cancelButtonProps: {
                                        'data-test': 'attachmentsPopConfirmCancelBtn',
                                        style: {
                                            borderRadius: 6
                                        }
                                    }, children: _jsx(Button, { disabled: loading || disabled, btntype: "danger", width: "100%", "data-test": "ticketRemoveAttachmentBtn", children: "Remove" }) }) })] }), _jsx(StyledRow, { gutter: 16, children: _jsx(Col, { span: 24, children: _jsx(FormItem, { name: (fieldName === null || fieldName === void 0 ? void 0 : fieldName.length)
                                    ? __spreadArray(__spreadArray([], fieldName, true), [index, 'notes'], false) : ['attachments', index, 'notes'], children: _jsx(TextArea, { rows: 5, placeholder: "Notes", disabled: loading || disabled, "data-test": "createTicketNotesTextArea" }) }) }) })] })] }));
};
export default NewAttachment;
